/*
 * @Author: mina.min
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-09-03 19:57:26
 * @FilePath: /OTA-frontend/src/services/campaign.ts
 * @Description: Campaign管理相关API服务
 */
import type { CampaignItem, CampaignListResponse } from '@/types'
import apiService from './api'

// 获取Campaign列表
export const getCampaignList = async (params: {
  pageNum?: string
  pageSize?: string
  keyword?: string
  status?: string
}): Promise<CampaignListResponse> => {
  const response = await apiService.get('/OTA-CampaignHandler/list', { params })
  return response as unknown as CampaignListResponse
}

// 创建Campaign
export const createCampaign = async (data: {
  campaignName: string
  firmwareIdList?: (string | number)[]
  version?: number
  status?: string
  remark?: string
}): Promise<{ code: string; info: string; data: string }> => {
  const response = await apiService.post('/OTA-CampaignHandler/save', data)
  return response as unknown as { code: string; info: string; data: string }
}

// 获取Campaign详情
export const getCampaignDetail = async (
  campaignId: string
): Promise<{
  code: string
  info: string
  data: CampaignItem | null
}> => {
  const response = await apiService.get('/OTA-CampaignHandler/detail', {
    params: { campaignId },
  })
  return response as unknown as {
    code: string
    info: string
    data: CampaignItem | null
  }
}

// 更新Campaign
export const updateCampaign = async (data: {
  campaignId: string
  campaignName?: string
  firmwareIdList?: (string | number)[]
  version?: number
  status?: string
  remark?: string
}): Promise<{ code: string; info: string; data: string }> => {
  const response = await apiService.post('/OTA-CampaignHandler/edit', data)
  return response as unknown as { code: string; info: string; data: string }
}

// 删除Campaign
export const deleteCampaign = async (
  campaignId: string
): Promise<{ code: string; info: string; data: string }> => {
  const response = await apiService.post('/OTA-CampaignHandler/delete', { campaignId })
  return response as unknown as { code: string; info: string; data: string }
}

// 发布Campaign
export const publishCampaign = async (
  campaignId: string
): Promise<{ code: string; info: string; data: string }> => {
  const response = await apiService.post('/OTA-CampaignHandler/publish', { campaignId })
  return response as unknown as { code: string; info: string; data: string }
}

// 获取可用的固件列表（用于Campaign选择）
export const getAvailableFirmwareList = async (params?: {
  phaseIds?: string[]
  moduleIds?: string[]
}): Promise<{
  code: string
  info: string
  data: Array<{ firmwareId: string; moduleName: string; firmwareVersion: number; remark?: string }>
}> => {
  // 使用新的固件列表接口，使用POST请求
  const requestData = {
    phaseIds: params?.phaseIds || [],
    moduleIds: params?.moduleIds || [],
  }

  const response = await apiService.post('/OTA-FirmwareHandler/getFirmwareList', requestData)
  return response as unknown as {
    code: string
    info: string
    data: Array<{
      firmwareId: string
      moduleName: string
      firmwareVersion: number
      remark?: string
    }>
  }
}

// 获取在线车辆列表（强制升级）
export const getOnlineDeviceList = async (): Promise<any[]> => {
  const res = (await apiService.get('/OTA-CampaignHandler/getOnlineDevices')) as any
  if (Array.isArray(res)) {
    return res
  }
  if (res && res.code === '200' && Array.isArray(res.data)) {
    return res.data
  }
  return []
}

// 获取已发布的Campaign，可用于前端选择可升级固件
export const getPublishedCampaignToFront = async (): Promise<{
  code: string
  info: string
  data: any[]
}> => {
  return (await apiService.get('/OTA-CampaignHandler/getPublishedCampaignToFront')) as unknown as {
    code: string
    info: string
    data: any[]
  }
}

// 向在线车辆推送强制升级请求
export const pushCampaignToOnlineDevice = async (data: {
  sn: string
  campaignId: string
}): Promise<{ successSn: string }> => {
  // 按接口要求使用 text/plain
  const res = await apiService.post(
    '/OTA-CampaignHandler/pushCampaignToOnlineDevice',
    JSON.stringify(data),
    {
      headers: {
        'Content-Type': 'text/plain',
      },
    }
  )
  return res as unknown as { successSn: string }
}
